import axios, { AxiosError, AxiosResponse } from 'axios';


axios.interceptors.request.use(async function (config) {
   var token = sessionStorage.getItem('authToken');
    if (token)
        config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default class Http {

    public static async getData(url: string): Promise<AxiosResponse> {
        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(response => {
                    // This block will not be reached on a 404
                    console.log('Response:', response.data);
                    resolve(response);
                })
                .catch(error => {
                    console.error('Error:', error);
                    resolve(error);
                })
        });
    }



    public static async post(url: string, data?: any): Promise<AxiosResponse | AxiosError> {
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        return new Promise((resolve, reject) => {

            axios.post(`${url}`, JSON.stringify(data), config).then(response => {
                // This block will not be reached on a 404
                console.log('Response:', response.data);
                resolve(response);
            })
                .catch(error => {
                    console.error('Error:', error);
                    resolve(error);
                })
        });

    }

    public static async put(url: string, data?: any): Promise<AxiosResponse> {
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        return new Promise((resolve, reject) => {

            axios.put(`${url}`, data, config).then(response => {
                // This block will not be reached on a 404
                console.log('Response:', response.data);
                resolve(response);
            })
                .catch(error => {
                    console.error('Error:', error);
                    reject(error);
                })
        });
    }

    public static async delete(url: string, data?: any): Promise<AxiosResponse> {

        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        return new Promise((resolve, reject) => {

            axios.delete(url, config).then(response => {
                // This block will not be reached on a 404
                console.log('Response:', response.data);
                resolve(response);
            })
                .catch(error => {
                    console.error('Error:', error);
                    reject(error);
                })
        });

    }


}
